import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import unescapedText from 'I18n/utils/unescapedText';
import { useState } from 'react';
import { ReviewWizard } from 'trellis-ecosystem';
import { EDIT_REASONS } from '../../constants/EditReasons';
import { useEcosystemReviews } from '../../hooks/useEcosystemReviews';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EcosystemReviewWizard({
  children,
  customValidationErrors,
  defaultReview,
  editedReview,
  HeaderComponent,
  offeringId,
  onChange,
  onClose,
  onFail,
  onSuccess,
  overrideSubmitValidation,
  ratingSection,
  requireEditReason = true,
  reviewFormatter,
  reviewType,
  showLegalCheckbox,
  validationSchema
}) {
  const isEditing = !!editedReview;
  const [editReason, setEditReason] = useState(requireEditReason ? '' : 'OTHER');
  const {
    finalizedDefaultReview,
    formattedCustomValidationErrors,
    formattedValidationSchema,
    handleChange,
    handleSubmit
  } = useEcosystemReviews({
    customValidationErrors,
    defaultReview,
    editedReview,
    editReason,
    offeringId,
    onChange,
    onFail,
    onSuccess,
    overrideSubmitValidation,
    reviewFormatter,
    reviewType,
    validationSchema
  });
  return /*#__PURE__*/_jsxs(ReviewWizard, {
    customValidationErrors: formattedCustomValidationErrors,
    defaultReview: finalizedDefaultReview,
    HeaderComponent: HeaderComponent,
    onChange: handleChange,
    onClose: onClose,
    onSubmit: handleSubmit,
    showLegalCheckbox: showLegalCheckbox,
    validationSchema: formattedValidationSchema,
    children: [ratingSection, isEditing && requireEditReason && /*#__PURE__*/_jsx(FormControl, {
      label: unescapedText('marketplace-ui-reviews.wizard.editReason'),
      required: true,
      children: /*#__PURE__*/_jsx(Select, {
        onChange: ({
          target: {
            value
          }
        }) => {
          setEditReason(value);
        },
        options: EDIT_REASONS.map(reason => ({
          value: reason,
          text: unescapedText(`marketplace-ui-reviews.wizard.editReasons.${reason}`)
        }))
      })
    }), children]
  });
}